module.exports = __webpack_public_path__ + "img/shazam-logo.bac17a49.svg";